import "./MultiQtyInputCell.css";
import RenderSvg from "../renderSvg/RenderSvg";
import { TextField } from "@mui/material";
import { useState } from "react";
import { getUomLabel } from "./DmsUtils";

interface MultiQtyInputCellProps {
  pcQty: number;
  csQty: number;
  otherQty: number;
  onQtyChange: (qtyObject:any)=>void;
  onClick?: (e: any) => void;
}

const MultiQtyInputCell: React.FC<MultiQtyInputCellProps> = ({
  pcQty,
  csQty,
  otherQty,
  onQtyChange,
  onClick
}) => {
  const { caseUnitLabel, otherUnitLabel, packUnitLabel } = getUomLabel();
  const [qtyObject, setQtyObject] = useState({
    pcQty:pcQty??0,
    csQty:csQty??0,
    otherQty:otherQty??0
  })

  const handleOnChange = (value:string, type:string)=>{
    const newObject:any = {...qtyObject};
    const newVal = parseInt(value.replace(/\D+/g, ''));
    newObject[type] = isNaN(newVal) ? 0 : newVal;
    setQtyObject(newObject);
    onQtyChange(newObject);
  }

  return (
    <div className="MultiQtyInputCell_root" onClick ={onClick}>
      <div
        className={`MultiQtyInputCell_parent_container ${otherUnitLabel ? "MultiQtyInputCell_3_uom" : ""}`}
      >
        {caseUnitLabel && <div className="MultiQtyInputCell_child_container">
          <input className="MultiQtyInputCell_input" value={qtyObject.csQty}  onChange={(e)=>{handleOnChange(e.target.value,"csQty")}}/>
          <div className="MultiQtyInputCell_label">{caseUnitLabel}</div>
        </div>}

        {otherUnitLabel && (
          <div className="MultiQtyInputCell_child_container">
            <input className="MultiQtyInputCell_input" value={qtyObject.otherQty} onChange={(e)=>{handleOnChange(e.target.value,"otherQty")}}/>
            <div className="MultiQtyInputCell_label">{otherUnitLabel}</div>
          </div>
        )}
        

        {packUnitLabel && <div className="MultiQtyInputCell_child_container">
          <input className="MultiQtyInputCell_input" value={qtyObject.pcQty} onChange={(e)=>{handleOnChange(e.target.value,"pcQty")}}/>
          <div className="MultiQtyInputCell_label">{packUnitLabel}</div>
        </div>}
      </div>
    </div>
  );
};

export default MultiQtyInputCell;
